import React, { useEffect, useState } from "react";
import DatePicker from "react-mobile-datepicker-jalaali-persian";
import PropTypes from "prop-types";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";

const month = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];
const dateConfigMap2 = {
  year: {
    format: "YYYY",
    caption: "سال",
    step: 1,
  },
  month: {
    format: (value) => month[value.jm - 1],
    caption: "ماه",
    step: 1,
  },
  date: {
    format: "D",
    caption: "روز",
    step: 1,
  },
};

const BirthDayDatePicker = (props) => {
  const { value, onChange } = props;
  const [birthday, setBirthday] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [val, setVal] = useState({ jy: 1399, jm: 11, jd: 11 });

  useEffect(() => {
    if (value) {
      const momentObject = moment(value);
      let bDay = momentObject.format("jYYYY/jMM/jDD");
      setBirthday(bDay);
      setVal({
        jy: Number(bDay.split("/")[0]),
        jm: Number(bDay.split("/")[1]),
        jd: Number(bDay.split("/")[2]),
      });
    }
    // eslint-disable-next-line
  }, []);

  function onClickInp() {
    setIsOpen(true);
  }

  function onChangeDatePicker(time) {
    setIsOpen(false);
    setVal(time);
    let result = `${time.jy}/${time.jm}/${time.jd}`;
    setBirthday(result);
    onChange(result);
  }

  return (
    <div style={{ position: "relative" }}>
      {/*<Input
        onClick={onClickInp}
        value={birthday ? birthday : ""}
        placeholder={"تاریخ تولد"}
      />*/}
      <div className="fake-input" onClick={onClickInp}>
        {birthday ? birthday : "تاریخ تولد"}
      </div>
      {birthday && (
        <div
          style={{
            width: "max-content",
            height: "max-content",
            position: "absolute",
            left: 0,
            padding: "1vh 1.5vh",
            top: "-0.3vh",
            zIndex: 10,
          }}
          onClick={() => {
            onChange("");
            setBirthday("");
          }}
        >
          <CloseCircleOutlined />
        </div>
      )}
      <DatePicker
        value={val}
        isOpen={isOpen}
        theme="ios"
        dateConfig={dateConfigMap2}
        onSelect={(item) => {
          /* do something */
          onChangeDatePicker(item);
        }}
        onCancel={(e) => {
          setIsOpen(false);
        }}
        confirmText="تایید"
        customHeader="تاریخ تولد"
        cancelText="بازگشت"
      />
    </div>
  );
};

BirthDayDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default BirthDayDatePicker;
